import store from "@/store";
export const uuid = () => {
  let s = [];
  let hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  let uuid = s.join("");
  return uuid;
};

/** 将路由 redirect 参数还原为可跳转的 hash 路径（如 /report/reportView/1/2?q=1） */
export function decodeRedirectPath(redirect) {
  if (!redirect) {
    return "";
  }

  let path = redirect;
  for (let i = 0; i < 5; i++) {
    if (!path.includes("%")) {
      break;
    }

    try {
      const decoded = decodeURIComponent(path);
      if (decoded === path) {
        break;
      }
      path = decoded;
    } catch (e) {
      break;
    }
  }

  return path;
}

export const AUTH_REDIRECT_STORAGE_KEY = "authRedirectPath";

export function isValidAuthRedirectPath(path) {
  if (!path || path === "/" || path === "/401" || path.includes("/login")) {
    return false;
  }
  return true;
}

/** 鉴权失败前暂存目标 hash 路径（如报表 deep link） */
export function saveAuthRedirectPath(path) {
  const target = path || getHashRoutePath();
  if (isValidAuthRedirectPath(target)) {
    sessionStorage.setItem(AUTH_REDIRECT_STORAGE_KEY, target);
    localStorage.setItem(AUTH_REDIRECT_STORAGE_KEY, target);
  }
}

/** 读取暂存路径（不删除，登录成功后再 clear） */
export function getAuthRedirectPath() {
  const path =
    sessionStorage.getItem(AUTH_REDIRECT_STORAGE_KEY) ||
    localStorage.getItem(AUTH_REDIRECT_STORAGE_KEY);
  return isValidAuthRedirectPath(path) ? path : "";
}

export function takeAuthRedirectPath() {
  const path = getAuthRedirectPath();
  if (path) {
    clearAuthRedirectPath();
  }
  return path;
}

export function clearAuthRedirectPath() {
  sessionStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY);
  localStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY);
}

/** 从当前 hash 解析路由路径（含 query），如 #/report/reportView/1/2?q=1 */
export function getHashRoutePath() {
  const hash = window.location.hash || "";
  if (!hash.startsWith("#/")) {
    return "";
  }
  const route = hash.slice(1);
  return route.startsWith("/") ? route : "";
}

/** 构造登录页 query，与 router defaultNext 编码方式一致 */
export function buildLoginRedirectQuery(redirectPath) {
  let path = redirectPath;
  if (!path || !isValidAuthRedirectPath(path)) {
    path = getAuthRedirectPath() || getHashRoutePath();
  }
  if (!path || !isValidAuthRedirectPath(path)) {
    return {};
  }
  return { redirect: encodeURIComponent(path) };
}

/** hash 路由模式下可靠跳转登录页并保留 redirect */
export function navigateToLoginWithRedirect(redirectPath) {
  const query = buildLoginRedirectQuery(redirectPath);
  const loginHash = query.redirect
    ? `#/login?redirect=${query.redirect}`
    : "#/login";
  const target = `${window.location.pathname}${window.location.search}${loginHash}`;
  window.location.replace(target);
}

/**多语言 */
export function translate(words, options) {
  return this.$t(words.replace(/\s*/g, "").toLowerCase(), options);
}

export function getToLowerCase(words) {
  return words.replace(/\s*/g, "").toLowerCase();
}
export function getStrLength(str) {
  let j = 0;
  let s = str;
  if (s == "") return j;
  for (let i = 0; i < s.length; i++) {
    if (s.substr(i, 1).charCodeAt(0) > 255) j = j + 2;
    else j++;
  }
  return j;
}
export const loadScript = (src) => {
  let head = document.querySelector("head");
  return new Promise((resolve, reject) => {
    let tableauJs = document.querySelector("tableauScript");
    if (tableauJs) {
      let dataSrc = tableauJs.getAttribute("data-src");
      if (dataSrc == src) {
        return resolve();
      } else {
        head.removeChild(tableauJs);
      }
    }
    let script = document.createElement("script");
    script.setAttribute("id", "tableauScript");
    script.setAttribute("data-src", src);
    script.type = "text/javascript";
    script.charset = "UTF-8";
    script.src = src;
    head.appendChild(script);
    if (script.addEventListener) {
      script.addEventListener(
        "load",
        () => {
          return resolve();
        },
        false
      );
      script.addEventListener(
        "error",
        () => {
          return reject();
        },
        false
      );
    } else if (script.attachEvent) {
      script.attachEvent("onreadystatechange", function () {
        let target = window.event.srcElement;
        if (target.readyState == "loaded") {
          return resolve();
        }
      });
    } else {
      return reject();
    }
  });
};

/**
 * 按一定比率回到顶部
 * @method scrollToTop
 * @param  {DOM}    scrollDom 滚动的元素
 * @param  {Number}    scale     时间间隔
 * @param  {Number}    time      比率
 * @return {Null}              未指定返回值
 */
export function scrollToTop(scrollDom, scale, time) {
  // 每次向顶部滚动 1/5 直至小于10
  let scrolling = setInterval(() => {
    let curScrollTop = scrollDom.scrollTop;
    if (curScrollTop < 10) {
      curScrollTop *= scale;
    }
    if (curScrollTop < 1) {
      clearInterval(scrolling);
    }
    scrollDom.scrollTop -= curScrollTop / scale;
  }, time);
}

/**
 * 节流函数
 * @method throttle
 * @param  {Function} fn      待执行的函数
 * @param  {Number}   delay   延时
 * @param  {Number}   atleast 最小执行间隔
 * @return {[type]}           [description]
 */
export function throttle(fn, delay, atleast) {
  let timer = null;
  let startTime = new Date();

  return function () {
    let context = this;
    let args = arguments;
    let curTime = new Date();

    clearTimeout(timer);
    if (curTime - startTime >= atleast) {
      fn.apply(context, args); // apply 指定函数指向的 上下文(this) 和 参数列表
      startTime = curTime;
    } else {
      timer = setTimeout(function () {
        fn.apply(context, args);
        startTime = curTime;
      }, delay);
    }
  };
}

export const deepParent = (arr, targetId) => {
  let parents = [];
  arr.some((item) => {
    let parent = null;
    if (item.id == targetId && !item.isReport) {
      parent = [{ name: item.label, id: item.id }];
    } else {
      if (item.children && item.children.length) {
        parents.push({ name: item.label, id: item.id });
        parent = deepParent(item.children, targetId);
      }
    }

    if (parent && parent !== undefined) {
      if (parent instanceof Array) {
        if (parent.length !== 0) {
          parents = parents.concat(parent);
        } else {
          parents = [];
        }
      } else {
        parents.push(parent);
      }
    }
    if (parents.length) {
      return true;
    }
  });
  return parents;
};
export const getDeepArrayFirst = (arr) => {
  for (const item of arr) {
    if (item.children === undefined) return item;
    if (item.children && item.children.length) {
      const _item = getDeepArrayFirst(item.children);
      if (_item) return _item;
    }
  }
};
export const getOrigin = (hash) => {
  const { protocol, hostname, pathname, port } = window.location;

  let currentPort = port ? ":" + port : "";

  let index = pathname.indexOf("/" + store.state.appName);

  let queryName = pathname.substring(0, index);

  return (
    protocol + "//" + hostname + currentPort + queryName + (hash ? hash : "")
  );
};

export const delCookie = () => {
  let keys = document.cookie.match(/[^ =;]+(?==)/g);
  if (keys) {
    for (let i = keys.length; i--;) {
      document.cookie =
        keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); // 清除当前域名下的
      document.cookie =
        keys[i] +
        "=0;path=/;domain=" +
        document.domain +
        ";expires=" +
        new Date(0).toUTCString(); // 清除当前域名下
    }
  }
};


export const isNumber = (val) => {
  return !isNaN(parseFloat(val)) && isFinite(val);
}